import request from '@/utils/request'
import qs from 'qs'


export function otherLogin(data) {
  return request({
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: '/srm-sys-server/api/login/otherlogin',
    method: 'post',
    data:qs.stringify(data)

  })
}
export function supplierOtherlogin(data) {
  return request({
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: '/srm-sys-server/api/login/supplierOtherlogin',
    method: 'post',
    data:qs.stringify(data)

  })
}
export function login(data) {
  return request({
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: '/srm-sys-server/api/login/login?msid='+data,
    method: 'post',
    // data:qs.stringify(data)

  })
}

export function getDesktopMenus(data) {
  return request({
    url: '/srm-sys-server/api/common/menu/getIndexMenus',
    method: 'post',
    data: qs.stringify(data)
  })
}
export function loginByMsid(data) {
  return request({
    url: '/srm-sys-server/api/login/login',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}
// 注册
export function enroll(data) {
  return request({
    url: '/srm-sys-server/api/login/register1',
    method: 'post',
    data: data
  })
}

// 注册
export function enroll2(data) {
  return request({
    url: '/srm-sys-server/api/supplier/login/register2',
    method: 'post',
    data: data
  })
}
//上传附件  /api/common/file/upload
export function upload(data) {
  return request({
    url: '/srm-sys-server/api/common/file/upload',
    method: 'post',
    data: data
  })
}

// 供应商名录  用户
export function getNumber(data) {
  return request({
    url: '/srm-sys-server/api/common/task/userBacklogRedDot',
    method: 'post',
    data: data
  })
}
//供应商名录   供应商
export function getNumberSupplier(data) {
  return request({
    url: '/srm-oem-server/api/common/oemCompanies/supplierBacklogRedDot',
    method: 'post',
    data: data
  })
}


//采购订单数量 
export function orderCount(data) {
  return request({
    url: '/srm-lkp-server/api/user/desktop/orderCount',
    method: 'get',
    data: data
  })
}

///supplier/desktop/infoCount  送货
export function infoCount(data) {
  return request({
    url: '/srm-lkp-server/api/supplier/desktop/infoCount ',
    method: 'get',
    data: data
  })
}

// /api/common/login/validation
export function validation(data) {
  return request({
    url: '/srm-sys-server/api/common/login/validation',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/modules/desktop/api/login.js